import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  SuccessResponse,
  X2AgeCategory,
  X2AgeCategoryUpdateModel
} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class EditAgeCategoryStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly ageCategory: X2AgeCategory) {
    makeObservable(this);
    this.name = new StringControl('name', ageCategory.Name, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;

    this.name.markTouched();
    if (this.name.invalid)
      return;
    const ageCategory = this.ageCategory;
    const model: X2AgeCategoryUpdateModel = {
      LanguageId: ageCategory.LanguageId,
      Index: ageCategory.Index,
      Name: this.name.value
    };
    this.save = contentLoaders.x2ageCategory.update(ageCategory.Id, model);
  }
}
